/**
 * Created by Mohamed on 12/9/2015.
 */
window.OBSendOfferModal = function ($scope, $filter, Upload, user, brandServices, userPermissions, onBoardingService, backgroundChecksService, positionsDataService, offerTemplatesService, $state, userServices, $modal) {
    var self = this;

    var MODAL_SELECTOR = "#ob_send_offer_modal";
    var SAVE_TEMPLATES_MODAL_SELECTOR = "#ob_save_offer_template_modal";

    var initialized = false;
    var closeModalTimeout = 0;

    var events = {
        "offer_sent": [],
        "irs_sent": [],
        "offer_shown": [],
        "offer_hidden": []
    };

    self.sendOfferForm = new SendOfferForm($scope, $filter, user, brandServices, onBoardingService, backgroundChecksService, positionsDataService, offerTemplatesService, $state, userServices);
    // Select offer from file flags
    self.sendOfferForm.selectedFile = null;
    self.OBIdObj = null;
	self.isEditOfferEnabled = false;
	self.isEditOfferDescriptionEnabled = false;
    self.onBoardingBrandSettings = {};

    self.onOfferSent = function(handler) {
        events["offer_sent"].push(handler);
    };

    self.onIrsSent = function (handler) {
        events["irs_sent"].push(handler);
    };
    self.onOfferShow = function(handler) {
        events["offer_shown"].push(handler);
    };

    self.onOfferHide = function(handler) {
        events["offer_hidden"].push(handler);
    };

    var trigger = function(eventName, param1, param2, param3, param4) {
        events[eventName].forEach(function(handler){
            handler(param1, param2, param3, param4);
        });
    };

    self.show = async (OBIdObj, offerId, offerSource, offerFileName, offerState) => {
        const irsForm = await OnBoardingAPI.listDocuments(OBIdObj.app_id, OBIdObj.prospect_id, 'ON_BOARDING', null, null, null, OnBoardingAPI.DOCUMENT_TYPE.IRS_8850);

        const proceedWithOffer = (OBIdObj, offerId, offerSource, offerFileName) => {

            trigger("offer_shown", self.OBIdObj);

            var initialPromises = {};
            initialPromises['policyParser'] = userPermissions.getBrandPolicy(OBIdObj.brand_id);
            initialPromises['onBoardingBrandSettings'] = onBoardingService.getOnboardingBrandSettings(OBIdObj.brand_id);

            $q.all(initialPromises)
                .then(function (result) {
                    if (result['policyParser']) {
                        var policyParser = result['policyParser'].position(OBIdObj.position.position_type.code, OBIdObj.position.code);

                        self.isEditOfferEnabled = policyParser.has(userPermissions.PERMISSIONS.MANAGE_DOCS_OFFERS);
                        self.isEditOfferDescriptionEnabled = policyParser.has(userPermissions.PERMISSIONS.MANAGE_DOCS_OFFERS_WITH_EDIT_DESCRIPTION);
                        self.hasManageBackgroundCheckSettings = policyParser.has(userPermissions.PERMISSIONS.MANAGE_BACKGROUND_CHECK_SETTINGS);
                        self.canManageOfferTemplates = policyParser.has(userPermissions.PERMISSIONS.MANAGE_OFFER_TEMPLATES);
                        self.canOverrideWageMatrix = policyParser.has(userPermissions.PERMISSIONS.OVERRIDE_WAGE_MATRIX);
                    }

                    if (result['onBoardingBrandSettings']) {
                        self.onBoardingBrandSettings = result['onBoardingBrandSettings'];
                    }

                })
                .catch(function (err) {
                    console.error(err);
                })
                .finally(function () {
                    self.showModalAfterCheckPermissions(OBIdObj, offerId, offerSource, offerFileName);
                });
        }

        const handleWageMatrixModal = async (OBIdObj, offerId, offerSource, offerFileName) => {
            const isWageMatrixServiceEnabled = await userServices.isServiceEnabled(userServices.SERVICES.WAGE_MATRIX, OBIdObj.brand_id);
            let allWageRules = [];
            let hasWageRuleWithAge = false;
            if (isWageMatrixServiceEnabled) {
                const wageRulesRes = await TeamAPI.getAllWageRules(OBIdObj.brand_id, OBIdObj?.position?.code);
                allWageRules = wageRulesRes?.wage_rules;
                if (allWageRules?.length > 0) {
                    hasWageRuleWithAge = allWageRules.some(wageRule =>
                        wageRule.wage_rule_rates.some(rate => Utils.isValidNumber(rate.from_age))
                    );
                }
            }

            if (!OBIdObj.birthdate && isWageMatrixServiceEnabled && hasWageRuleWithAge) {
                $modal({
                    controller: 'WageMatrixBirthdateModalController',
                    controllerAs: '$ctrl',
                    templateUrl: '../modules/on_boarding/modals/wage-matrix-birthdate/wage-matrix-birthdate.modal.html',
                    show: true,
                    backdrop: 'static',
                    resolve: {
                        modalData: () => {
                            return {
                                brandId: OBIdObj.brand_id,
                                prospectId: OBIdObj.candidate_id || OBIdObj.prospect_id
                            };
                        },
                        onSuccess: () => {
                            return (data) => {
                                OBIdObj.birthdate = data.birthdate;
                                proceedWithOffer(OBIdObj, offerId, offerSource, offerFileName);
                            };
                        },
                        onClose: () => {
                            return () => {
                            };
                        }
                    }
                });
            } else {
                proceedWithOffer(OBIdObj, offerId, offerSource, offerFileName);
            }
        };
        if (irsForm.length && !irsForm[0]?.Document && !offerState) {
            hConfirm({
                title: $filter('translate')('IRS (Form 8850)'),
                text: $filter('translate')('Please make sure to submit IRS Form 8850 before sending an offer, as you won\'t be able to send it afterward.'),
                cancelButton: $filter("translate")("Proceed with the offer"),
                confirmButton: $filter('translate')('Send form 8850'),
                callback: function (confirmed) {
                    if (confirmed) {
                        let documents = [
                            {
                                "metadata": {},
                                "code": "IRS_8850",
                                "set": "NY"
                            }
                        ];
                        let prospect = {
                            "user_id": OBIdObj.candidate_id,
                            "brand_id": OBIdObj.brand_id,
                            "job_id": OBIdObj.job_id,
                            "position_id": OBIdObj.position.id,
                            "application_id": OBIdObj.app_id
                        }
                        OnBoardingAPI.sendDocuments(prospect, documents, offerSource)
                            .then(() => {
                                trigger("irs_sent");
                            })
                            .catch((err) => {
                                console.error(err);
                                if (err?.data?.data?.errors[0]?.code === OnBoardingAPI.SEND_DOCUMNTS_ERROR_CODES.IRS_ERROR) {
                                    hAlert($filter("translate")("Error"), $filter("translate")("You can’t send the IRS (Form 8850) after the offer."));
                                }
                            })
                    } else {
                        handleWageMatrixModal(OBIdObj, offerId, offerSource, offerFileName);
                    }
                }
            });
        } else {
            handleWageMatrixModal(OBIdObj, offerId, offerSource, offerFileName);
        }
    };

    self.showModalAfterCheckPermissions = function (OBIdObj, offerId, offerSource, offerFileName) {
        self.OBIdObj = OBIdObj;
        self.offer_source = offerSource;
        self.offer_id = offerId;
        self.offer_file_name = offerFileName;

        brandServices.check(brandServices.SERVICES.ATR, self.OBIdObj.brand_id)
            .then(function (isATREnabled) {
                if (isATREnabled) {
                    ATRAPI.getBrandSettings(OBIdObj.brand_id)
                        .then(function (atrSettings) {
                            if (atrSettings.atr_type !== "MB") {
                                if (self.OBIdObj.job_id) {
                                    ATRAPI.getJobATR(self.OBIdObj.brand_id, self.OBIdObj.job_id)
                                        .then(function (res) {
                                            if (res.atrs && res.atrs.length) {
                                                var result = $.grep(res.atrs, function (e) {
                                                    return e.status == "ATTACHED" || e.status == "OFFERED";
                                                });
                                                if (result.length == 0) {
                                                    showATRConfirmationMessage(self.OBIdObj.job_id);
                                                    return false;
                                                } else {
                                                    showOfferSendModal(OBIdObj, offerId, offerSource, offerFileName)
                                                }
                                            } else {
                                                var needAtrConfirmationMsg = false;
                                                var activePosition = (self.OBIdObj.job && self.OBIdObj.job.Position) || self.OBIdObj.position || self.OBIdObj.positions[0];
                                                switch (atrSettings.atr_type) {
                                                    case "BNB_WORKDAY":
                                                        var isPositionNeedAtr = atrSettings.positions.some(function (item) {
                                                            return item.code === activePosition.code;
                                                        });
                                                        needAtrConfirmationMsg = isPositionNeedAtr;
                                                        break;
                                                    case "EPS":
                                                        needAtrConfirmationMsg = true;
                                                        break;
                                                }
                                                if (needAtrConfirmationMsg) {
                                                    showATRConfirmationMessage(self.OBIdObj.job_id);
                                                    return false;
                                                } else {
                                                    showOfferSendModal(OBIdObj, offerId, offerSource, offerFileName)
                                                }
                                            }
                                        });
                                }
                                else if (self.OBIdObj.positions[0] && self.OBIdObj.positions[0].code) {
                                    ATRAPI.getPositionATR(self.OBIdObj.brand_id, self.OBIdObj.positions[0].code)
                                        .then(function (res) {
                                            var isAtrRequired = false;
                                            switch (atrSettings.atr_type) {
                                                case "BNB_WORKDAY":
                                                    var isPositionNeedAtr = atrSettings.positions.some(function (item) {
                                                        return item.code === self.OBIdObj.positions[0].code;
                                                    });
                                                    isAtrRequired = isPositionNeedAtr;
                                                    break;
                                                case "EPS":
                                                    isAtrRequired = true;
                                                    break;
                                            }
                                            if (isAtrRequired) {
                                                if (res.atrs && res.atrs.length) {
                                                    var result = $.grep(res.atrs, function (e) {
                                                        return e.status == "ATTACHED" || e.status == "AVAILABLE";
                                                    });
                                                    if (result.length == 0) {
                                                        showATRConfirmationMessageNojob();
                                                        return false;
                                                    } else {
                                                        showOfferSendModal(OBIdObj, offerId, offerSource, offerFileName)
                                                    }
                                                } else {
                                                    showATRConfirmationMessageNojob();
                                                    return false;
                                                }
                                            } else {
                                                showOfferSendModal(OBIdObj, offerId, offerSource, offerFileName)
                                            }
                                        });
                                }
                            } else {
                                showOfferSendModal(OBIdObj, offerId, offerSource, offerFileName)
                            }
                        });
                }
                else {
                    showOfferSendModal(OBIdObj, offerId, offerSource, offerFileName)
                }
            });

    };

    var showOfferSendModal = function (OBIdObj, offerId, offerSource, offerFileName) {
        self.sendOfferForm.setUserPermissions({
            isEditOfferEnabled: self.isEditOfferEnabled,
            isEditOfferDescriptionEnabled: self.isEditOfferDescriptionEnabled,
            hasManageBackgroundCheckSettings: self.hasManageBackgroundCheckSettings,
            canManageOfferTemplates: self.canManageOfferTemplates,
            canOverrideWageMatrix: self.canOverrideWageMatrix
        });

        self.sendOfferForm.load(OBIdObj, offerId, offerSource, offerFileName);

        $(MODAL_SELECTOR).modal("show");

        if (!initialized) {
            initialized = true;
            $(MODAL_SELECTOR).on('hidden.bs.modal', function () {
                self.destroy();
            });
        }
    }

    var showATRConfirmationMessage = function (jobId) {
        hConfirm({
            title: $filter("translate")("Missing ATR"),
            text: $filter("translate")("There are no available ATRs for this job post. In order to proceed, please edit the job post and attach available ATRs."),
            confirmButton: $filter("translate")("Edit Job Post"),
            callback:function(confirmed){
                if (confirmed) {
                    hRedirect('job/create/' + jobId);
                }
            }});
    };

    var showATRConfirmationMessageNojob = function () {
        hAlert($filter("translate")("Missing ATR"), $filter("translate")("There are no available ATRs for this position. In order to proceed, please add ATRs to that position."));
    };

    self.deleteUploadedOffer = function() {
        self.offer_id = null;
        self.offer_source = null;
    };

    self.hide = function () {
        $(MODAL_SELECTOR).modal("hide");
        trigger("offer_hidden", self.OBIdObj);
    };

    self.destroy = function () {

        if (self.sendOfferForm) {
            self.sendOfferForm.destroy();
        }

        delete self.offerSentSuccess;
        self.deleteUploadedOffer();
        self.sendOfferForm.selectedFile = null;
        self.OBIdObj = null;
        delete self.isUploading;
        delete self.sendOfferForm.isUploading;
        clearTimeout(closeModalTimeout);

        $scope.$digest();
    };

    self.sendOffer = function() {

        if (self.sendOfferForm.selectedFile) {
            self.isUploading = true;
            self.sendOfferForm.isUploading = true;

            var uploadData = {
                document_lookup_code : OnBoardingAPI.DOCUMENT_TYPE.OFFER,
                action_type: 'SEND_OFFER'
            };

            if (self.OBIdObj.prospect_id) {
                uploadData.prospect_id = self.OBIdObj.prospect_id;
            }
            else {
                uploadData.prospect = JSON.stringify({
                    "user_id" : self.OBIdObj.candidate_id,
                    "brand_id" : self.OBIdObj.brand_id,
                    "job_id": self.OBIdObj.job_id,
                    "position_id" : self.OBIdObj.positions[0].id,
                    "application_id" : self.OBIdObj.app_id
                });
            }

            Upload.upload({
                url: publicConfiguration.OnboardingServerBaseURL + 'document_upload',
                withCredentials: true,
                headers: {},
                method: "PUT",
                data: uploadData,
                file: self.sendOfferForm.selectedFile
            }).progress(function (evt) {
                var uploaded = evt.loaded || 0;
                var total = evt.total;
                self.uploadProgress = 100 * uploaded/total;
            }).success(function (data, status, headers, config) {
                self.isUploading = false;
                self.sendOfferForm.isUploading = false;
                self.uploadProgress = 0;

                if (data.status_code == 200 && data.data) {
                    handleOfferSent(data.data);
                }
                else {
                    hAlert($filter("translate")("Error Sending Offer"), (data.data.error || data.data));
                }

            }).error(function (reason) {
                self.isUploading = false;
                self.sendOfferForm.isUploading = false;
                console.error(reason);
            });

            $scope.$digest();
        }
        else if (self.sendOfferForm.validator.validate()) {
            self.isUploading = true;

            self.sendOfferForm.sendOffer()
                .then(function(result) {
                    self.isUploading = false;
                    handleOfferSent(result);
                },
                function(err) {
                    self.isUploading = false;
                    $scope.$digest();
                });

        }
        else if(!self.sendOfferForm.validator.validate()) {
            self.offerSentSuccess = false;

            setTimeout(function() {
                var formName = 'send-offer-form';
                $(MODAL_SELECTOR).scrollTop(0);
                $(MODAL_SELECTOR).scrollTop(($('.' + formName + ' .error').first().offset().top - 100));
                }, 100);
        }
    };

    var handleOfferSent = function(result) {
        trigger("offer_sent", self.OBIdObj, result);
        self.offerSentSuccess = true;
        self.offerState = result?.sent[0]?.state;
        $(MODAL_SELECTOR).scrollTop(0);

        // Hide offer modal after 3 seconds
        closeModalTimeout = setTimeout(function() {
            self.hide();
        }, 3000);

        setTimeout(function() {
            $scope.$digest();
        }, 100);
    };

    self.removeSource = function () {
        self.offer_source = self.sendOfferForm.offer_source = null;
    }

    self.loadTemplate = function() {
        self.sendOfferForm.loadTemplate();
        self.unselectFile();
        self.deleteUploadedOffer();
    };

    self.showSaveTemplates = function () {
        if (self.sendOfferForm.selected_position && self.sendOfferForm.selected_position.id) {
            self.sendOfferForm.initSaveOfferTemplateModal();
            $(SAVE_TEMPLATES_MODAL_SELECTOR).modal("show");
        } else {
	        self.sendOfferForm.validator.validation['position_id'] = { errors: {'required': true}};
        }
    };

    self.hideSaveTemplates = function () {
        $(SAVE_TEMPLATES_MODAL_SELECTOR).modal("hide");
    };

    self.unselectFile = function() {
        self.sendOfferForm.selectedFile = null;
    };

    self.getOfferData = function () {
        return self.sendOfferForm.getOfferData();
    };

    self.saveTemplate = function(update) {
        self.savingOfferTemplate = true;
        self.sendOfferForm.saveTemplate(update)
            .then(function () {
                self.hideSaveTemplates();
            })
            .catch(function (err) {
                if (err) {
                    if (err.data.data.code === offerTemplatesService.ERROR_CODES.ATTACHED_TO_AUTOMATION_RULE_EXCEPTION) {
                        HNotifications.show({
                            title: $filter("translate")("Template locked"),
                            desc: $filter("translate")("This template is used in an automation flow, please unlink first from the automation to edit this template.") ,
                            icon: "fa-times",
                            type: "danger",
                            timeout: 5000
                        });
                    } else {
                        hAlert({
                            title: $filter('translate')('Error'),
                            text: $filter('translate')('Something went wrong while saving the template!')
                        })
                    }
                    console.error(err);
                }
            })
            .finally(function () {
                self.savingOfferTemplate = false;
            });
    }

};
